const OFFER_BASE = "https://top1.bstcasfs.com/click";
const OFFER_ID = "3240";

/**
 * Формат як у офера: ?pid=…&offer_id=3240&sub1=… (один & між параметрами).
 */
export function buildOfferClickUrl() {
  const sp =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search)
      : null;
  const ls = typeof window !== "undefined" ? window.localStorage : null;

  const pid =
    (sp && sp.get("pid")) ||
    (ls && ls.getItem("pid")) ||
    (sp && sp.get("id")) ||
    (ls && ls.getItem("id")) ||
    "";

  const sub1 =
    (sp && sp.get("sub1")) ||
    (ls && ls.getItem("sub1")) ||
    (sp && sp.get("sub_id_1")) ||
    (ls && ls.getItem("sub_id_1")) ||
    (ls && ls.getItem("external_id")) ||
    "";

  const qPid = encodeURIComponent(pid);
  const qSub1 = encodeURIComponent(sub1);

  return `${OFFER_BASE}?pid=${qPid}&offer_id=${OFFER_ID}&sub1=${qSub1}`;
}
